import React, {useContext} from 'react';
import { ViewportContext } from '../../context/ViewPort';
import { graphql } from "gatsby";
import HtmlBlock from '../htmlBlock/htmlBlock';
import ModuleWrapper from '../../globals/moduleWrapper/moduleWrapper';
import RenderMedia from '../../lib/renders/renderMedia';

/**
 * CMS Component: DatoCmsComponentMobileDesktopVersion
 * For displaying different media for desktop and mobile
 * 
 */
const Media = ({data, className, ...other}) => {
    const {copy, desktop, heading, mobile} = data || {};
    const hasMobile = mobile && mobile.length > 0;
    const { screenSize } = useContext(ViewportContext);

    // console.log(desktop, mobile);
    return (
      <ModuleWrapper className={`media ${className || ''}`} {...other}>
        {
          heading && <HtmlBlock tag={'h2'} className={`h3`} data={heading} />
        }
        {
          copy && <HtmlBlock tag={'p'} data={copy} />
        }
        {
          (hasMobile && screenSize==='mobile') && <RenderMedia data={mobile} />
        }
        {
          desktop && (screenSize!=='mobile' || !hasMobile) &&  <RenderMedia data={desktop} />
        }
      </ModuleWrapper>
    );
};

export default Media;

export const MobileDesktopVersionFragment = graphql`
fragment MobileDesktopVersionFragment on DatoCmsComponentMobileDesktopVersion {
  id: originalId
  copy: content
  heading
  mobile{
    __typename
    ...ImageLayoutFragment
    ...VideoFragment
  }
  desktop{
    __typename
    ...ImageLayoutFragment
    ...VideoFragment  
  }
}
`;